import { render, staticRenderFns } from "./frecuentQuestions.vue?vue&type=template&id=74456ee5&"
import script from "./frecuentQuestions.vue?vue&type=script&lang=js&"
export * from "./frecuentQuestions.vue?vue&type=script&lang=js&"
import style0 from "./frecuentQuestions.vue?vue&type=style&index=0&id=74456ee5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports